import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-silkshore.webp"
            alt="Silkshore"
          />
        </p>
        <strong>The “red lamp district” and artist community.</strong>{" "}
        <em>
          Criss-crossed by dozens of narrow <strong>canals</strong>, Silkshore
          is a district best navigated by <strong>gondola</strong>, as most
          visitors to this “<strong>red lamp district</strong>” do. The{" "}
          <strong>brothels, vice dens, food stalls, and exotic shops</strong>{" "}
          all perch at the waterside, ready to satisfy the appetites of their
          clientele, no questions asked. Silkshore is a place of{" "}
          <strong>public indulgence and private indelicacy</strong>, catering to
          every pleasure imaginable—as well as some that strain the bounds of
          fantasy.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-silkshore.webp"
          alt="Silkshore"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Hundreds of gondolas gliding to and fro
                in the spiderweb of canals, carrying eager patrons to the bounty
                of pleasure-houses and vice dens. Artists and philosophers
                arguing epistemology over Iruvian tea at the cafes on Fogcrest
                hill.
                <br />
                <strong>Streets:</strong> The few remaining surface streets are
                interrupted at every turn by a bridge over a tiny canal. Colored
                lights and patterned silks hang roof to roof, signaling various
                indugences in a complex code for the initiated. Greenwater,
                Highwater, Chimewater, Ringwater, Sweetwater.
                <br />
                <strong>Buildings:</strong> Tall, narrow rowhouses of wood and
                stone. Low canal-side shacks and stalls. Cramped old stone
                houses and converted offices on Fogcrest hill.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. Consulate Offices</li>
                  <li>2. The Hive</li>
                  <li>3. The Wraiths</li>
                  <li>4. The Unseen</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-silkshore.webp"
                  alt="Silkshore district traits"
                />
                <br />
                <em>
                  Should you overindulge your vice while in Silkshore, you’ll
                  get a taste for it. Take <strong>+1d</strong> to your roll the
                  next time you indulge your vice here.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Silkshore Locations</h1>
        <strong>
          <u>Ankhayat Park</u>
        </strong>
        : This extravagantly landscaped space is the largest open area in the
        city, hosting many public festivals and events throughout the year. The
        Iruvian noble for whom the park is named keeps a falcon aviary and
        stable of fine horses at the park and sometimes organizes gamehawking
        for the nobility.
        <br />
        <br />
        <strong>
          <u>The Ease</u>
        </strong>
        : The northern part of the district is more easily navigated by gondola
        than by coach, and the dozens of entryways into the canals are flanked
        by shops and brothels advertising their wares with colored electric
        lights and flying banners.
        <br />
        <br />
        <strong>
          <u>Fogcrest</u>
        </strong>
        : A high, peaked hilltop crowded with rowhouses jammed within the maze
        of narrow stairways that constitute its “streets.” A bohemian community
        of artists, free-thinkers, psychedelic explorers, and philosophers.
        <br />
        <br />
        <strong>
          <u>The Spark Grounds</u>
        </strong>
        : Beneath the crackling flares of a lightning tower, this open field
        draws crowds to watch the death-defying stunts of acrobats and circus
        performers, including the notorious “spark flyers” who soar in manned
        kites adorned with bits of metal to attract arcs of electricity from the
        barrier in a pyrotechnic display.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Silkshore = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Silkshore;
